import { getCertificates, setIsLoadingCertificate } from './certificatesReducer';
import acApi from '../../axios/ac/acApi';
import { showToastNotification } from '../ui/toasts/toastsActions';
import { ToastType } from '../ui/toasts/toastsTypes';
import { forceBrowserToDownloadData, getErrorMessage } from '../../utils/miscUtil';
import { Dispatch } from 'redux';
import _ from 'lodash';
import { Asset, Certificate } from '../../types/rest/assetCatalogTypes';
import store from '../configureStore';

/**
 * Fetch certificates from backend.
 * @param forceReload - if set to true, the fetch will be forced. If false, existing list in redux is going to be used.
 * @param silentReload - if set to true, loading indicator will not be shown.
 */
export const fetchCertificatesThunk = (forceReload?: boolean, silentReload?: boolean) => {
  return async (dispatch: Dispatch, getState: any): Promise<void> => {
    const certList = getState().certificates.certificates;
    if (forceReload !== true && !_.isEmpty(certList)) {
      return;
    }

    if (silentReload !== true) {
      dispatch(setIsLoadingCertificate(true));
    }
    try {
      const response = await acApi.assets.getAssets('CERTIFICATE');
      const certs = response.data.result;
      dispatch(getCertificates(certs));
    } catch (e) {
      dispatch(showToastNotification(ToastType.Danger, 'Cannot get list of certificates', getErrorMessage(e)));
    } finally {
      dispatch(setIsLoadingCertificate(false));
    }
  };
};

export const downloadAsset = (asset: Asset) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(showToastNotification(ToastType.Success, `Successfully initiated ${asset.name} download`));
      const response = (await acApi.assets.getById(asset.id)).data.result;
      const base64DecodedStr = atob(response.data);
      const base64DecodedArray = Uint8Array.from(base64DecodedStr, m => m.codePointAt(0));
      forceBrowserToDownloadData(base64DecodedArray, asset.name);
    } catch (e) {
      dispatch(showToastNotification(ToastType.Danger, 'Cannot download selected asset', getErrorMessage(e)));
    }
  };
};

export const updateMetadata = async (asset: Asset | Certificate) => {
  try {
    const response = await acApi.assets.updateAsset(asset);
    return response;
  } catch (e) {
    const error = getErrorMessage(e);
    store.dispatch(showToastNotification(ToastType.Danger, 'Cannot update Asset Metadata.', error));
  } finally {
    //Also update list of certificates
    store.dispatch(fetchCertificatesThunk(true, false) as any);
  }
};

export const validate = async (certId: number, propagateError: boolean) => {
  try {
    const response = await acApi.assets.validate(certId);
    return response;
  } catch (e) {
    if (propagateError) {
      throw e;
    } else {
      const error = getErrorMessage(e);
      store.dispatch(showToastNotification(ToastType.Danger, 'Cannot update Asset Metadata.', error));
    }
  } finally {
    //Also update list of certificates
    store.dispatch(fetchCertificatesThunk(true, false) as any);
  }
};
